import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    /* Row templates vary with which of header / description / images the
       CMS provides, via the mobile-rows-N classes from index.js. */
    .miles-layout.mobile-rows-1 {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    .miles-layout.mobile-rows-2 {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    .miles-layout.mobile-rows-3 {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    .miles-layout.mobile-rows-1 h2,
    .miles-layout.mobile-rows-1 .description,
    .miles-layout.mobile-rows-1 .images,
    .miles-layout.mobile-rows-2 h2,
    .miles-layout.mobile-rows-2 .description,
    .miles-layout.mobile-rows-3 h2 {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .miles-layout.mobile-rows-2 .images,
    .miles-layout.mobile-rows-3 .description {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .miles-layout.mobile-rows-3 .images {
      grid-column: 2 / 8;
      grid-row: 4;
    }

    h2 {
      height: fit-content;
      margin-bottom: var(--between-row-padding);
    }

    /* Cards are driver-card elements; the element's h4-medium title default
       matches the design, so only spacing is set here. */
    .image-wrapper {
      --driver-card-gap: 0;
    }

    .image-wrapper::part(title) {
      padding-top: calc(10rem / var(--default-rem-px-count));
    }

    .description {
      height: fit-content;
      margin-bottom: var(--between-row-padding-lg);
    }

    /* Card descriptions read at the body scale in the mock. */
    .image-wrapper::part(description) {
      padding-top: calc(6rem / var(--default-rem-px-count));
      font-size: var(--fs-body);
      line-height: var(--lh-body);
      letter-spacing: var(--ls-body);
    }

    /* Card grid: 2-up mobile; a nested 12-column grid at 600px+ so card
       edges land on the page grid lines, 4-up via span 3. */
    .images {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: var(--between-row-padding-lg) var(--between-column-padding-lg);
    }

    @media (min-width: 600px) {
      /* Top-row texts share a first baseline. */
      .miles-layout.mobile-rows-1 h2,
      .miles-layout.mobile-rows-2 h2,
      .miles-layout.mobile-rows-3 h2 {
        grid-column: 2 / 7;
        grid-row: 2;
        align-self: baseline;
      }

      .miles-layout.mobile-rows-1 .description,
      .miles-layout.mobile-rows-2 .description,
      .miles-layout.mobile-rows-3 .description {
        grid-column: 8 / 14;
        grid-row: 2;
        align-self: baseline;
      }

      .miles-layout.mobile-rows-1 .images {
        grid-column: 2 / 14;
        grid-row: 2;
      }

      .miles-layout.mobile-rows-2 .images,
      .miles-layout.mobile-rows-3 .images {
        grid-column: 2 / 14;
        grid-row: 3;
      }

      .four-per-row .image-wrapper {
        grid-column: span 3;
      }

      .six-per-row .image-wrapper {
        grid-column: span 4;
      }

      h2 {
        margin-bottom: calc(60rem / var(--default-rem-px-count));
      }

      .description {
        margin-bottom: calc(60rem / var(--default-rem-px-count));
      }

      .images {
        grid-template-columns: repeat(12, minmax(0, 1fr));
        gap: var(--between-row-padding-lg) var(--between-column-padding);
      }

      /* Column rules for the vertical_line_breaks CMS option. Half-gutter
         padding + negative margin centers the border in the gutter without
         changing card content width. Row starters (4n + 1) get no rule. */
      .four-per-row.images.vertical-lines
        > .image-wrapper:not(:nth-child(4n + 1)) {
        border-left: 1px solid rgba(0, 0, 0, 0.18);
        padding-left: calc(var(--between-column-padding) / 2);
        margin-left: calc(-1 * var(--between-column-padding) / 2);
      }

      .six-per-row.images.vertical-lines
        > .image-wrapper:not(:nth-child(3n + 1)) {
        border-left: 1px solid rgba(0, 0, 0, 0.18);
        padding-left: calc(var(--between-column-padding) / 2);
        margin-left: calc(-1 * var(--between-column-padding) / 2);
      }
    }

    @media (min-width: 1024px) {
      .miles-layout.mobile-rows-1 h2,
      .miles-layout.mobile-rows-2 h2,
      .miles-layout.mobile-rows-3 h2 {
        grid-column: 2 / 6;
      }

      .miles-layout.mobile-rows-1 .description,
      .miles-layout.mobile-rows-2 .description,
      .miles-layout.mobile-rows-3 .description {
        grid-column: 6 / 10;
      }
      .six-per-row .image-wrapper {
        grid-column: span 2;
      }

      .six-per-row.images.vertical-lines
        > .image-wrapper:not(:nth-child(6n + 1)) {
        border-left: 1px solid rgba(0, 0, 0, 0.18);
        padding-left: calc(var(--between-column-padding) / 2);
        margin-left: calc(-1 * var(--between-column-padding) / 2);
      }
    }
  `,
];
